import { Subjects, TAppAbility } from "./AbilityContext";

export type CompoundPermission = {
    list: Subjects[];
    operator: "or" | "and";
};

export const compoundPermissions = (permissions: CompoundPermission[], ability: TAppAbility): boolean => {
    return permissions.some(({ list, operator }) => {
        let permissionsInclusive = false;
        let permissionExclusive = false;

        if (operator === "and") {
            permissionsInclusive = list.every((permission) => ability.can("see", permission));
        } else if (operator === "or") {
            permissionExclusive = list.some((permission) => ability.can("see", permission));
        }

        return permissionsInclusive || permissionExclusive;
    });
};
